var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("vuestic-widget", { attrs: { headerText: "Colorful Bars" } }, [
    _c("div", { staticClass: "va-row" }, [
      _c(
        "div",
        { staticClass: "flex sm4 md4" },
        [
          _vm._v(
            "\n      " +
              _vm._s(_vm._f("translate")("progressBars.basic")) +
              "\n      "
          ),
          _c("vuestic-progress-bar", {
            attrs: { value: 100, theme: "Danger" },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "flex sm4 md4" },
        [
          _vm._v(
            "\n      " +
              _vm._s(_vm._f("translate")("progressBars.thin")) +
              "\n      "
          ),
          _c("vuestic-progress-bar", {
            attrs: { value: 100, size: "thin", theme: "Info" },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "flex sm4 md4" },
        [
          _vm._v(
            "\n      " +
              _vm._s(_vm._f("translate")("progressBars.thick")) +
              "\n      "
          ),
          _c("vuestic-progress-bar", {
            attrs: { value: 100, size: "thick", theme: "Warning" },
          }),
        ],
        1
      ),
    ]),
    _c("div", { staticClass: "va-row" }, [
      _c("div", { staticClass: "flex sm4 md4" }, [
        _vm._v(
          "\n      " +
            _vm._s(_vm._f("translate")("progressBars.basicVertical")) +
            "\n      "
        ),
        _c(
          "div",
          { staticClass: "pb-container" },
          [
            _c("vuestic-progress-bar", {
              attrs: { value: 100, type: "vertical", theme: "Success" },
            }),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "flex sm4 md4" }, [
        _vm._v(
          "\n      " +
            _vm._s(_vm._f("translate")("progressBars.thinVertical")) +
            "\n      "
        ),
        _c(
          "div",
          { staticClass: "pb-container" },
          [
            _c("vuestic-progress-bar", {
              attrs: {
                value: 100,
                size: "thin",
                type: "vertical",
                theme: "Black",
              },
            }),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "flex sm4 md4" }, [
        _vm._v(
          "\n      " +
            _vm._s(_vm._f("translate")("progressBars.circle")) +
            "\n      "
        ),
        _c(
          "div",
          { staticClass: "pb-container" },
          [
            _c("vuestic-progress-bar", {
              attrs: { value: 100, type: "circle" },
            }),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }